import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Style from './Description.module.scss';

const Description = ({ isDropActive = false, isSameDay = false }) => {
  const {
    nft_activeDescription = 'Join to unlock the surprises.',
    nft_sameDayDescription = 'Get ready for THE MASKED SINGER NFT Drop. Drop Starts in:',
    nft_upcomingDescription = 'Get ready for THE MASKED SINGER NFT Drop. Drop Starts in:',
  } = window.Language;
  let description = nft_upcomingDescription;
  if (isSameDay) description = nft_sameDayDescription;
  if (isDropActive) description = nft_activeDescription;
  return (
    <div className={classnames(Style.description, isDropActive && Style.activeDescription)}>
      {description}
    </div>
  );
};

Description.propTypes = {
  isDropActive: PropTypes.bool,
  isSameDay: PropTypes.bool,
};

export default Description;
